var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.207 5.825a4.748 4.748 0 0 1 .01 6.706l-.01.011-2.1 2.1a4.755 4.755 0 0 1-6.718 0 4.755 4.755 0 0 1 0-6.717l1.16-1.16a.5.5 0 0 1 .853.332c.02.553.12 1.11.302 1.647a.503.503 0 0 1-.118.52l-.409.408c-.876.876-.903 2.302-.036 3.186a2.253 2.253 0 0 0 3.198.016l2.1-2.1a2.25 2.25 0 0 0-.323-3.45.501.501 0 0 1-.217-.393c-.013-.33.104-.67.365-.932l.658-.658a.502.502 0 0 1 .643-.054c.23.16.444.34.642.538zM14.61 1.42a4.755 4.755 0 0 0-6.718 0l-2.1 2.1-.01.012a4.748 4.748 0 0 0 .652 7.243c.2.14.47.119.643-.054l.658-.658c.26-.26.378-.601.365-.931a.501.501 0 0 0-.217-.394 2.25 2.25 0 0 1-.323-3.45l2.1-2.1a2.253 2.253 0 0 1 3.198.016c.867.884.84 2.31-.036 3.186l-.41.41a.503.503 0 0 0-.117.518c.183.538.282 1.094.302 1.648a.5.5 0 0 0 .853.331l1.16-1.16a4.755 4.755 0 0 0 0-6.717z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.fef1d4a63516c1489c4851686f4f8dd9.svg";
export { ForwardRef as ReactComponent };